import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createTextVNode as _createTextVNode, vShow as _vShow, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "user-statement-wrapper" }
const _hoisted_2 = { class: "statement-header" }
const _hoisted_3 = { class: "header-content" }
const _hoisted_4 = {
  key: 0,
  class: "user-info"
}
const _hoisted_5 = { class: "user-details" }
const _hoisted_6 = { class: "user-id" }
const _hoisted_7 = {
  key: 1,
  class: "header-title"
}
const _hoisted_8 = { class: "header-actions" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "filters-section" }
const _hoisted_11 = { class: "filters-title" }
const _hoisted_12 = {
  key: 0,
  class: "active-filters-count"
}
const _hoisted_13 = { class: "filters-content" }
const _hoisted_14 = { class: "quick-filters" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "filter-icon" }
const _hoisted_17 = { class: "filter-fields" }
const _hoisted_18 = { class: "filter-field" }
const _hoisted_19 = { class: "filter-field" }
const _hoisted_20 = { class: "filter-field" }
const _hoisted_21 = { class: "filter-field" }
const _hoisted_22 = { class: "filter-field full-width" }
const _hoisted_23 = { class: "filter-field full-width" }
const _hoisted_24 = { class: "filter-actions" }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = ["disabled"]
const _hoisted_27 = {
  key: 0,
  class: "loading-container"
}
const _hoisted_28 = {
  key: 1,
  class: "empty-container"
}
const _hoisted_29 = { class: "empty-content" }
const _hoisted_30 = { class: "empty-text" }
const _hoisted_31 = {
  key: 2,
  class: "statement-table-container"
}
const _hoisted_32 = { class: "table-header" }
const _hoisted_33 = { class: "table-title" }
const _hoisted_34 = { class: "table-subtitle" }
const _hoisted_35 = { class: "table-responsive" }
const _hoisted_36 = { class: "statement-table" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "col-number" }
const _hoisted_39 = { class: "row-number" }
const _hoisted_40 = { class: "col-action" }
const _hoisted_41 = { class: "action-wrapper" }
const _hoisted_42 = { class: "action-text" }
const _hoisted_43 = { class: "action-title" }
const _hoisted_44 = { class: "action-subtitle" }
const _hoisted_45 = {
  class: "col-amount",
  dir: "rtl"
}
const _hoisted_46 = { class: "amount-wrapper flex items-center gap-x-2 relative" }
const _hoisted_47 = ["title", "onMouseenter"]
const _hoisted_48 = {
  key: 0,
  class: "amount-tooltip"
}
const _hoisted_49 = { class: "tooltip-content" }
const _hoisted_50 = { class: "tooltip-body" }
const _hoisted_51 = { class: "tooltip-row" }
const _hoisted_52 = { class: "tooltip-value" }
const _hoisted_53 = { class: "tooltip-row" }
const _hoisted_54 = { class: "tooltip-value" }
const _hoisted_55 = { class: "tooltip-row" }
const _hoisted_56 = { class: "tooltip-value" }
const _hoisted_57 = { class: "tooltip-row" }
const _hoisted_58 = { class: "tooltip-value" }
const _hoisted_59 = { class: "tooltip-row" }
const _hoisted_60 = { class: "tooltip-value" }
const _hoisted_61 = { class: "tooltip-row" }
const _hoisted_62 = { class: "tooltip-value" }
const _hoisted_63 = { class: "tooltip-row" }
const _hoisted_64 = { class: "tooltip-value" }
const _hoisted_65 = { class: "tooltip-row" }
const _hoisted_66 = { class: "tooltip-value" }
const _hoisted_67 = { class: "tooltip-row" }
const _hoisted_68 = { class: "tooltip-row" }
const _hoisted_69 = { class: "col-currency" }
const _hoisted_70 = { class: "col-status" }
const _hoisted_71 = { class: "col-description" }
const _hoisted_72 = {
  class: "description-wrapper",
  dir: "rtl"
}
const _hoisted_73 = { class: "description-text" }
const _hoisted_74 = { class: "description-meta flex items-center gap-x-2" }
const _hoisted_75 = { class: "meta-date" }
const _hoisted_76 = {
  key: 0,
  class: "meta-ref"
}
const _hoisted_77 = { class: "col-final-balance" }
const _hoisted_78 = { class: "balance-wrapper" }
const _hoisted_79 = { class: "balance-main" }
const _hoisted_80 = { class: "balance-currency" }
const _hoisted_81 = {
  key: 0,
  class: "balance-change"
}
const _hoisted_82 = {
  key: 3,
  class: "pagination-container"
}
const _hoisted_83 = { class: "pagination-info" }
const _hoisted_84 = { class: "pagination-controls" }
const _hoisted_85 = ["disabled"]
const _hoisted_86 = ["disabled"]
const _hoisted_87 = { class: "pagination-pages" }
const _hoisted_88 = { class: "current-page" }
const _hoisted_89 = { class: "total-pages" }
const _hoisted_90 = ["disabled"]
const _hoisted_91 = ["disabled"]
const _hoisted_92 = { class: "dialog-header" }
const _hoisted_93 = { class: "dialog-content" }
const _hoisted_94 = {
  key: 0,
  class: "metadata-content"
}
const _hoisted_95 = { class: "metadata-section" }
const _hoisted_96 = { class: "metadata-grid" }
const _hoisted_97 = { class: "metadata-item" }
const _hoisted_98 = { class: "metadata-value" }
const _hoisted_99 = { class: "metadata-item" }
const _hoisted_100 = { class: "metadata-value" }
const _hoisted_101 = { class: "metadata-item" }
const _hoisted_102 = { class: "metadata-value" }
const _hoisted_103 = { class: "metadata-item" }
const _hoisted_104 = { class: "metadata-value" }
const _hoisted_105 = { class: "metadata-item" }
const _hoisted_106 = { class: "metadata-value" }
const _hoisted_107 = { class: "metadata-item" }
const _hoisted_108 = { class: "metadata-value" }
const _hoisted_109 = {
  key: 0,
  class: "metadata-section text-left",
  dir: "ltr"
}
const _hoisted_110 = { class: "metadata-json text-left" }
const _hoisted_111 = { dir: "ltr" }
const _hoisted_112 = {
  key: 1,
  class: "metadata-section"
}
const _hoisted_113 = { class: "metadata-grid" }
const _hoisted_114 = {
  key: 0,
  class: "metadata-item"
}
const _hoisted_115 = { class: "metadata-value" }
const _hoisted_116 = {
  key: 1,
  class: "metadata-item"
}
const _hoisted_117 = { class: "metadata-value" }
const _hoisted_118 = {
  key: 2,
  class: "metadata-item"
}
const _hoisted_119 = { class: "metadata-value" }
const _hoisted_120 = {
  key: 2,
  class: "metadata-section"
}
const _hoisted_121 = { class: "metadata-grid" }
const _hoisted_122 = {
  key: 0,
  class: "metadata-item"
}
const _hoisted_123 = { class: "metadata-value" }
const _hoisted_124 = {
  key: 1,
  class: "metadata-item"
}
const _hoisted_125 = { class: "metadata-value" }
const _hoisted_126 = {
  key: 2,
  class: "metadata-item"
}
const _hoisted_127 = { class: "metadata-value" }
const _hoisted_128 = {
  key: 3,
  class: "metadata-item"
}
const _hoisted_129 = { class: "metadata-value" }
const _hoisted_130 = {
  key: 4,
  class: "metadata-item"
}
const _hoisted_131 = { class: "metadata-value" }
const _hoisted_132 = {
  key: 5,
  class: "metadata-item"
}
const _hoisted_133 = { class: "metadata-value" }
const _hoisted_134 = {
  key: 6,
  class: "metadata-item"
}
const _hoisted_135 = { class: "metadata-value" }
const _hoisted_136 = {
  key: 7,
  class: "metadata-item"
}
const _hoisted_137 = { class: "metadata-value" }
const _hoisted_138 = {
  key: 8,
  class: "metadata-item"
}
const _hoisted_139 = { class: "metadata-value" }
const _hoisted_140 = {
  key: 9,
  class: "metadata-item"
}
const _hoisted_141 = { class: "metadata-value" }
const _hoisted_142 = {
  key: 10,
  class: "metadata-item"
}
const _hoisted_143 = { class: "metadata-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RefreshIcon = _resolveComponent("RefreshIcon")!
  const _component_Filter = _resolveComponent("Filter")!
  const _component_ChevronDown = _resolveComponent("ChevronDown")!
  const _component_CheckIcon = _resolveComponent("CheckIcon")!
  const _component_XIcon = _resolveComponent("XIcon")!
  const _component_ChevronLeft = _resolveComponent("ChevronLeft")!
  const _component_ChevronRight = _resolveComponent("ChevronRight")!
  const _component_X = _resolveComponent("X")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.user)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _cache[19] || (_cache[19] = _createElementVNode("div", { class: "user-avatar" }, [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  stroke: "currentColor"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                  })
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h2", null, _toDisplayString(_ctx.user.name || 'کاربر'), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.user.email), 1),
                _createElementVNode("span", _hoisted_6, "شناسه: " + _toDisplayString(_ctx.user.id), 1)
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[20] || (_cache[20] = [
              _createElementVNode("h2", null, "گردش حساب مالی کاربر", -1),
              _createElementVNode("p", null, "مشاهده کامل تراکنش‌های مالی و تغییرات موجودی", -1)
            ]))]))
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.refreshData && _ctx.refreshData(...args))),
          class: "refresh-btn",
          disabled: _ctx.loading
        }, [
          _createVNode(_component_RefreshIcon, {
            class: _normalizeClass({ 'animate-spin': _ctx.loading })
          }, null, 8, ["class"]),
          _cache[21] || (_cache[21] = _createElementVNode("span", null, "بروزرسانی", -1))
        ], 8, _hoisted_9)
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", {
        class: "filters-header",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showFilters = !_ctx.showFilters))
      }, [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_Filter),
          _cache[22] || (_cache[22] = _createElementVNode("span", null, "فیلترهای پیشرفته", -1)),
          (_ctx.activeFiltersCount > 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.activeFiltersCount), 1))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_ChevronDown, {
          class: _normalizeClass(["chevron", { 'rotated': _ctx.showFilters }])
        }, null, 8, ["class"])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (cat) => {
            return (_openBlock(), _createElementBlock("button", {
              key: cat.value,
              onClick: ($event: any) => (_ctx.selectCategory(cat.value)),
              class: _normalizeClass(['filter-btn', { 'active': _ctx.localFilters.category === cat.value }])
            }, [
              _createElementVNode("span", _hoisted_16, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(cat.icon)))
              ]),
              _createElementVNode("span", null, _toDisplayString(cat.label), 1)
            ], 10, _hoisted_15))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _cache[24] || (_cache[24] = _createElementVNode("label", null, "ارز", -1)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localFilters.currency) = $event))
            }, [...(_cache[23] || (_cache[23] = [
              _createStaticVNode("<option value=\"\" data-v-cbf51cb6>همه ارزها</option><option value=\"RIALI\" data-v-cbf51cb6>ریالی (تومان)</option><option value=\"IRT\" data-v-cbf51cb6>تومان</option><option value=\"IR\" data-v-cbf51cb6>ریال</option><option value=\"USDT\" data-v-cbf51cb6>تتر (USDT)</option><option value=\"USD\" data-v-cbf51cb6>دلار</option>", 6)
            ]))], 512), [
              [_vModelSelect, _ctx.localFilters.currency]
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _cache[26] || (_cache[26] = _createElementVNode("label", null, "وضعیت", -1)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.localFilters.status) = $event))
            }, [...(_cache[25] || (_cache[25] = [
              _createStaticVNode("<option value=\"\" data-v-cbf51cb6>همه وضعیت‌ها</option><option value=\"SUCCESS\" data-v-cbf51cb6>موفق</option><option value=\"PENDING\" data-v-cbf51cb6>در انتظار</option><option value=\"FAILED\" data-v-cbf51cb6>ناموفق</option><option value=\"CANCELLED\" data-v-cbf51cb6>لغو شده</option>", 5)
            ]))], 512), [
              [_vModelSelect, _ctx.localFilters.status]
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _cache[27] || (_cache[27] = _createElementVNode("label", null, "حداقل مبلغ", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.localFilters.minAmount) = $event)),
              type: "number",
              placeholder: "0",
              min: "0"
            }, null, 512), [
              [
                _vModelText,
                _ctx.localFilters.minAmount,
                void 0,
                { number: true }
              ]
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _cache[28] || (_cache[28] = _createElementVNode("label", null, "حداکثر مبلغ", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.localFilters.maxAmount) = $event)),
              type: "number",
              placeholder: "نامحدود",
              min: "0"
            }, null, 512), [
              [
                _vModelText,
                _ctx.localFilters.maxAmount,
                void 0,
                { number: true }
              ]
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _cache[29] || (_cache[29] = _createElementVNode("label", null, "از تاریخ", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.localFilters.from) = $event)),
              type: "date"
            }, null, 512), [
              [_vModelText, _ctx.localFilters.from]
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _cache[30] || (_cache[30] = _createElementVNode("label", null, "تا تاریخ", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.localFilters.to) = $event)),
              type: "date"
            }, null, 512), [
              [_vModelText, _ctx.localFilters.to]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("button", {
            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args))),
            class: "apply-btn",
            disabled: _ctx.loading
          }, [
            _createVNode(_component_CheckIcon),
            _cache[31] || (_cache[31] = _createTextVNode(" اعمال فیلترها ", -1))
          ], 8, _hoisted_25),
          _createElementVNode("button", {
            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.clearFilters && _ctx.clearFilters(...args))),
            class: "clear-btn",
            disabled: _ctx.loading
          }, [
            _createVNode(_component_XIcon),
            _cache[32] || (_cache[32] = _createTextVNode(" پاک کردن ", -1))
          ], 8, _hoisted_26)
        ])
      ], 512), [
        [_vShow, _ctx.showFilters]
      ])
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [...(_cache[33] || (_cache[33] = [
          _createElementVNode("div", { class: "loading-content" }, [
            _createElementVNode("div", { class: "loading-spinner" }),
            _createElementVNode("div", { class: "loading-text" }, [
              _createElementVNode("h3", null, "در حال بارگذاری..."),
              _createElementVNode("p", null, "گردش حساب مالی کاربر در حال دریافت است")
            ])
          ], -1)
        ]))]))
      : (_ctx.logs.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _cache[37] || (_cache[37] = _createElementVNode("div", { class: "empty-icon" }, [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  stroke: "currentColor"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                  })
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_30, [
                _cache[35] || (_cache[35] = _createElementVNode("h3", null, "هیچ تراکنشی یافت نشد", -1)),
                _cache[36] || (_cache[36] = _createElementVNode("p", null, "تراکنش‌های مالی کاربر در اینجا نمایش داده می‌شود", -1)),
                _createElementVNode("button", {
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.refreshData && _ctx.refreshData(...args))),
                  class: "retry-btn"
                }, [
                  _createVNode(_component_RefreshIcon),
                  _cache[34] || (_cache[34] = _createTextVNode(" تلاش مجدد ", -1))
                ])
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _cache[38] || (_cache[38] = _createElementVNode("h3", null, "گردش حساب مالی", -1)),
                _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.pagination.totalItems) + " تراکنش یافت شد", 1)
              ]),
              _cache[39] || (_cache[39] = _createElementVNode("div", null, null, -1))
            ]),
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("table", _hoisted_36, [
                _cache[52] || (_cache[52] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", { class: "col-number" }, "#"),
                    _createElementVNode("th", { class: "col-action" }, "نوع تراکنش"),
                    _createElementVNode("th", { class: "col-amount" }, "مبلغ"),
                    _createElementVNode("th", { class: "col-currency" }, "ارز"),
                    _createElementVNode("th", { class: "col-status" }, "وضعیت"),
                    _createElementVNode("th", { class: "col-description" }, "توضیح"),
                    _createElementVNode("th", { class: "col-final-balance" }, "مانده پس از تراکنش")
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.logs, (log, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      onClick: ($event: any) => (_ctx.openMetadataDialog(log)),
                      key: log.id,
                      class: _normalizeClass(["statement-row cursor-pointer", _ctx.getRowClass(log.action)])
                    }, [
                      _createElementVNode("td", _hoisted_38, [
                        _createElementVNode("span", _hoisted_39, _toDisplayString(((_ctx.pagination.page - 1) * _ctx.pagination.pageSize) + index + 1), 1)
                      ]),
                      _createElementVNode("td", _hoisted_40, [
                        _createElementVNode("div", _hoisted_41, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["action-icon", _ctx.getActionBadgeClass(log.action)])
                          }, [
                            (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.getActionIcon(log.action))))
                          ], 2),
                          _createElementVNode("div", _hoisted_42, [
                            _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.getActionTitle(log.action)), 1),
                            _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.getActionSubtitle(log.action)), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_45, [
                        _createElementVNode("div", _hoisted_46, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["amount-sign", _ctx.getAmountClass(log.action)])
                          }, _toDisplayString(_ctx.getAmountSign(log.action)), 3),
                          _createElementVNode("span", {
                            class: _normalizeClass(["amount-value", _ctx.getAmountClass(log.action)]),
                            title: _ctx.getAmountTooltip(log),
                            onMouseenter: ($event: any) => (_ctx.showTooltip = log.id),
                            onMouseleave: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showTooltip = null))
                          }, _toDisplayString(_ctx.formatCurrency(log.amount)), 43, _hoisted_47),
                          (_ctx.showTooltip === log.id && log.type === 'FINANCIAL' && log.action === 'ORDER_FILLED' && log.metadata)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                _createElementVNode("div", _hoisted_49, [
                                  _cache[50] || (_cache[50] = _createElementVNode("div", { class: "tooltip-header" }, [
                                    _createElementVNode("span", { class: "tooltip-title" }, "جزئیات سفارش")
                                  ], -1)),
                                  _createElementVNode("div", _hoisted_50, [
                                    _createElementVNode("div", _hoisted_51, [
                                      _cache[40] || (_cache[40] = _createElementVNode("span", { class: "tooltip-label" }, "نوع سفارش:", -1)),
                                      _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.getOrderTypeLabel(log.metadata.orderType as string)), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_53, [
                                      _cache[41] || (_cache[41] = _createElementVNode("span", { class: "tooltip-label" }, "مقدار:", -1)),
                                      _createElementVNode("span", _hoisted_54, _toDisplayString(log.metadata.totalAmount as string) + " " + _toDisplayString(_ctx.getCurrencyLabel(log.currency)), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_55, [
                                      _cache[42] || (_cache[42] = _createElementVNode("span", { class: "tooltip-label" }, "قیمت میانگین:", -1)),
                                      _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.formatCurrency(log.metadata.averagePrice as number)) + " تومان", 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_57, [
                                      _cache[43] || (_cache[43] = _createElementVNode("span", { class: "tooltip-label" }, "ارزش کل:", -1)),
                                      _createElementVNode("span", _hoisted_58, _toDisplayString(_ctx.formatCurrency(log.metadata.totalValue as number)) + " تومان", 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_59, [
                                      _cache[44] || (_cache[44] = _createElementVNode("span", { class: "tooltip-label" }, "موجودی قبلی ریالی:", -1)),
                                      _createElementVNode("span", _hoisted_60, _toDisplayString(_ctx.formatCurrency(log.metadata.previousBalanceRial as number)) + " تومان", 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_61, [
                                      _cache[45] || (_cache[45] = _createElementVNode("span", { class: "tooltip-label" }, "موجودی جدید ریالی:", -1)),
                                      _createElementVNode("span", _hoisted_62, _toDisplayString(_ctx.formatCurrency(log.metadata.newBalanceRial as number)) + " تومان", 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_63, [
                                      _cache[46] || (_cache[46] = _createElementVNode("span", { class: "tooltip-label" }, "موجودی قبلی تتر:", -1)),
                                      _createElementVNode("span", _hoisted_64, _toDisplayString(log.metadata.previousBalanceUsdt as string) + " USDT", 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_65, [
                                      _cache[47] || (_cache[47] = _createElementVNode("span", { class: "tooltip-label" }, "موجودی جدید تتر:", -1)),
                                      _createElementVNode("span", _hoisted_66, _toDisplayString(log.metadata.newBalanceUsdt as string) + " USDT", 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_67, [
                                      _cache[48] || (_cache[48] = _createElementVNode("span", { class: "tooltip-label" }, "تغییر موجودی ریالی:", -1)),
                                      _createElementVNode("span", {
                                        class: _normalizeClass(["tooltip-value", _ctx.getMetadataBalanceChangeClass(log.metadata.balanceChangeRial as string)])
                                      }, _toDisplayString(_ctx.formatCurrency(Math.abs(parseFloat(log.metadata.balanceChangeRial as string)))) + " تومان ", 3)
                                    ]),
                                    _createElementVNode("div", _hoisted_68, [
                                      _cache[49] || (_cache[49] = _createElementVNode("span", { class: "tooltip-label" }, "تغییر موجودی تتر:", -1)),
                                      _createElementVNode("span", {
                                        class: _normalizeClass(["tooltip-value", _ctx.getMetadataBalanceChangeClass(log.metadata.balanceChangeUsdt as string)])
                                      }, _toDisplayString(Math.abs(parseFloat(log.metadata.balanceChangeUsdt as string))) + " USDT ", 3)
                                    ])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_69, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["currency-badge", _ctx.getCurrencyClass(log.currency)])
                        }, _toDisplayString(_ctx.getCurrencyLabel(log.currency)), 3)
                      ]),
                      _createElementVNode("td", _hoisted_70, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["status-badge", 'status-' + log.status?.toLowerCase()])
                        }, [
                          _cache[51] || (_cache[51] = _createElementVNode("span", { class: "status-dot" }, null, -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.getStatusLabel(log.status)), 1)
                        ], 2)
                      ]),
                      _createElementVNode("td", _hoisted_71, [
                        _createElementVNode("div", _hoisted_72, [
                          _createElementVNode("p", _hoisted_73, _toDisplayString(log.description), 1),
                          _createElementVNode("div", _hoisted_74, [
                            _createElementVNode("span", _hoisted_75, _toDisplayString(_ctx.formatDateShort(log.createdAt)) + " " + _toDisplayString(_ctx.formatTime(log.createdAt)), 1),
                            (log.referenceId)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_76, "کد: " + _toDisplayString(log.referenceId), 1))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_77, [
                        _createElementVNode("div", _hoisted_78, [
                          _createElementVNode("div", _hoisted_79, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["balance-value", _ctx.getAmountClass(log.action)])
                            }, _toDisplayString(_ctx.formatCurrency(_ctx.getDisplayBalance(log))), 3),
                            _createElementVNode("span", _hoisted_80, _toDisplayString(_ctx.getCurrencyLabel(log.currency)), 1)
                          ]),
                          (log.previousBalance && log.newBalance)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["change-indicator", _ctx.getBalanceChangeClass(log)])
                                }, _toDisplayString(_ctx.getBalanceChange(log)), 3)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ], 10, _hoisted_37))
                  }), 128))
                ])
              ])
            ])
          ])),
    (_ctx.pagination.totalPages > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
          _createElementVNode("div", _hoisted_83, [
            _createElementVNode("span", null, "نمایش " + _toDisplayString(((_ctx.pagination.page - 1) * _ctx.pagination.pageSize) + 1) + " تا " + _toDisplayString(Math.min(_ctx.pagination.page * _ctx.pagination.pageSize, _ctx.pagination.totalItems)) + " از " + _toDisplayString(_ctx.pagination.totalItems) + " تراکنش", 1)
          ]),
          _createElementVNode("div", _hoisted_84, [
            _createElementVNode("button", {
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.goToPage(1))),
              disabled: _ctx.pagination.page === 1 || _ctx.loading,
              class: "pagination-btn",
              title: "صفحه اول"
            }, [
              _createVNode(_component_ChevronLeft)
            ], 8, _hoisted_85),
            _createElementVNode("button", {
              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.goToPage(_ctx.pagination.page - 1))),
              disabled: _ctx.pagination.page === 1 || _ctx.loading,
              class: "pagination-btn",
              title: "صفحه قبل"
            }, [
              _createVNode(_component_ChevronLeft)
            ], 8, _hoisted_86),
            _createElementVNode("div", _hoisted_87, [
              _createElementVNode("span", _hoisted_88, _toDisplayString(_ctx.pagination.page), 1),
              _cache[53] || (_cache[53] = _createElementVNode("span", { class: "page-separator" }, "/", -1)),
              _createElementVNode("span", _hoisted_89, _toDisplayString(_ctx.pagination.totalPages), 1)
            ]),
            _createElementVNode("button", {
              onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.goToPage(_ctx.pagination.page + 1))),
              disabled: !_ctx.pagination.hasMore || _ctx.loading,
              class: "pagination-btn",
              title: "صفحه بعد"
            }, [
              _createVNode(_component_ChevronRight)
            ], 8, _hoisted_90),
            _createElementVNode("button", {
              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.goToPage(_ctx.pagination.totalPages))),
              disabled: _ctx.pagination.page === _ctx.pagination.totalPages || _ctx.loading,
              class: "pagination-btn",
              title: "صفحه آخر"
            }, [
              _createVNode(_component_ChevronRight)
            ], 8, _hoisted_91)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showMetadataDialog)
      ? (_openBlock(), _createElementBlock("div", {
          key: 4,
          class: "metadata-dialog-overlay",
          onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.closeMetadataDialog && _ctx.closeMetadataDialog(...args)))
        }, [
          _createElementVNode("div", {
            class: "metadata-dialog",
            onClick: _cache[17] || (_cache[17] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("div", _hoisted_92, [
              _cache[54] || (_cache[54] = _createElementVNode("h3", null, "جزئیات متادیتا", -1)),
              _createElementVNode("button", {
                onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.closeMetadataDialog && _ctx.closeMetadataDialog(...args))),
                class: "close-btn"
              }, [
                _createVNode(_component_X)
              ])
            ]),
            _createElementVNode("div", _hoisted_93, [
              (_ctx.selectedLog)
                ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                    _createElementVNode("div", _hoisted_95, [
                      _cache[61] || (_cache[61] = _createElementVNode("h4", null, "اطلاعات اصلی", -1)),
                      _createElementVNode("div", _hoisted_96, [
                        _createElementVNode("div", _hoisted_97, [
                          _cache[55] || (_cache[55] = _createElementVNode("span", { class: "metadata-label" }, "شناسه:", -1)),
                          _createElementVNode("span", _hoisted_98, _toDisplayString(_ctx.selectedLog.id), 1)
                        ]),
                        _createElementVNode("div", _hoisted_99, [
                          _cache[56] || (_cache[56] = _createElementVNode("span", { class: "metadata-label" }, "نوع:", -1)),
                          _createElementVNode("span", _hoisted_100, _toDisplayString(_ctx.selectedLog.type), 1)
                        ]),
                        _createElementVNode("div", _hoisted_101, [
                          _cache[57] || (_cache[57] = _createElementVNode("span", { class: "metadata-label" }, "عملیات:", -1)),
                          _createElementVNode("span", _hoisted_102, _toDisplayString(_ctx.selectedLog.action), 1)
                        ]),
                        _createElementVNode("div", _hoisted_103, [
                          _cache[58] || (_cache[58] = _createElementVNode("span", { class: "metadata-label" }, "وضعیت:", -1)),
                          _createElementVNode("span", _hoisted_104, _toDisplayString(_ctx.getStatusLabel(_ctx.selectedLog.status)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_105, [
                          _cache[59] || (_cache[59] = _createElementVNode("span", { class: "metadata-label" }, "مبلغ:", -1)),
                          _createElementVNode("span", _hoisted_106, _toDisplayString(_ctx.formatCurrency(_ctx.selectedLog.amount)) + " " + _toDisplayString(_ctx.getCurrencyLabel(_ctx.selectedLog.currency)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_107, [
                          _cache[60] || (_cache[60] = _createElementVNode("span", { class: "metadata-label" }, "تاریخ:", -1)),
                          _createElementVNode("span", _hoisted_108, _toDisplayString(_ctx.formatDate(_ctx.selectedLog.createdAt)), 1)
                        ])
                      ])
                    ]),
                    (_ctx.selectedLog.metadata)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
                          _cache[62] || (_cache[62] = _createElementVNode("h4", null, "جزئیات متادیتا", -1)),
                          _createElementVNode("div", _hoisted_110, [
                            _createElementVNode("pre", _hoisted_111, _toDisplayString(_ctx.formatMetadata(_ctx.selectedLog.metadata)), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.selectedLog.user || _ctx.selectedLog.admin || _ctx.selectedLog.targetUser)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                          _cache[66] || (_cache[66] = _createElementVNode("h4", null, "اطلاعات کاربران", -1)),
                          _createElementVNode("div", _hoisted_113, [
                            (_ctx.selectedLog.user)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_114, [
                                  _cache[63] || (_cache[63] = _createElementVNode("span", { class: "metadata-label" }, "کاربر اصلی:", -1)),
                                  _createElementVNode("span", _hoisted_115, _toDisplayString(_ctx.selectedLog.user.name) + " (" + _toDisplayString(_ctx.selectedLog.user.email) + ")", 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.selectedLog.admin)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_116, [
                                  _cache[64] || (_cache[64] = _createElementVNode("span", { class: "metadata-label" }, "ادمین:", -1)),
                                  _createElementVNode("span", _hoisted_117, _toDisplayString(_ctx.selectedLog.admin.name) + " (" + _toDisplayString(_ctx.selectedLog.admin.email) + ")", 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.selectedLog.targetUser)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_118, [
                                  _cache[65] || (_cache[65] = _createElementVNode("span", { class: "metadata-label" }, "کاربر هدف:", -1)),
                                  _createElementVNode("span", _hoisted_119, _toDisplayString(_ctx.selectedLog.targetUser.name) + " (" + _toDisplayString(_ctx.selectedLog.targetUser.email) + ")", 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.selectedLog.referenceId || _ctx.selectedLog.relatedTable || _ctx.selectedLog.targetUserId || _ctx.selectedLog.adminId || _ctx.selectedLog.ipAddress || _ctx.selectedLog.device)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_120, [
                          _cache[78] || (_cache[78] = _createElementVNode("h4", null, "اطلاعات تکمیلی", -1)),
                          _createElementVNode("div", _hoisted_121, [
                            (_ctx.selectedLog.referenceId)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_122, [
                                  _cache[67] || (_cache[67] = _createElementVNode("span", { class: "metadata-label" }, "کد پیگیری:", -1)),
                                  _createElementVNode("span", _hoisted_123, _toDisplayString(_ctx.selectedLog.referenceId), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.selectedLog.relatedTable)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_124, [
                                  _cache[68] || (_cache[68] = _createElementVNode("span", { class: "metadata-label" }, "جدول مرتبط:", -1)),
                                  _createElementVNode("span", _hoisted_125, _toDisplayString(_ctx.selectedLog.relatedTable), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.selectedLog.targetUserId)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_126, [
                                  _cache[69] || (_cache[69] = _createElementVNode("span", { class: "metadata-label" }, "کاربر هدف:", -1)),
                                  _createElementVNode("span", _hoisted_127, _toDisplayString(_ctx.selectedLog.targetUserId), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.selectedLog.adminId)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_128, [
                                  _cache[70] || (_cache[70] = _createElementVNode("span", { class: "metadata-label" }, "ادمین:", -1)),
                                  _createElementVNode("span", _hoisted_129, _toDisplayString(_ctx.selectedLog.adminId), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.selectedLog.ipAddress)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_130, [
                                  _cache[71] || (_cache[71] = _createElementVNode("span", { class: "metadata-label" }, "آدرس IP:", -1)),
                                  _createElementVNode("span", _hoisted_131, _toDisplayString(_ctx.selectedLog.ipAddress), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.selectedLog.device)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_132, [
                                  _cache[72] || (_cache[72] = _createElementVNode("span", { class: "metadata-label" }, "دستگاه:", -1)),
                                  _createElementVNode("span", _hoisted_133, _toDisplayString(_ctx.selectedLog.device), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.selectedLog.previousBalance)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_134, [
                                  _cache[73] || (_cache[73] = _createElementVNode("span", { class: "metadata-label" }, "موجودی قبلی:", -1)),
                                  _createElementVNode("span", _hoisted_135, _toDisplayString(_ctx.formatCurrency(_ctx.selectedLog.previousBalance)) + " " + _toDisplayString(_ctx.getCurrencyLabel(_ctx.selectedLog.currency)), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.selectedLog.newBalance)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_136, [
                                  _cache[74] || (_cache[74] = _createElementVNode("span", { class: "metadata-label" }, "موجودی جدید:", -1)),
                                  _createElementVNode("span", _hoisted_137, _toDisplayString(_ctx.formatCurrency(_ctx.selectedLog.newBalance)) + " " + _toDisplayString(_ctx.getCurrencyLabel(_ctx.selectedLog.currency)), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.selectedLog.errorMessage)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_138, [
                                  _cache[75] || (_cache[75] = _createElementVNode("span", { class: "metadata-label" }, "پیام خطا:", -1)),
                                  _createElementVNode("span", _hoisted_139, _toDisplayString(_ctx.selectedLog.errorMessage), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.selectedLog.reason)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_140, [
                                  _cache[76] || (_cache[76] = _createElementVNode("span", { class: "metadata-label" }, "دلیل:", -1)),
                                  _createElementVNode("span", _hoisted_141, _toDisplayString(_ctx.selectedLog.reason), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.selectedLog.isRead !== undefined)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_142, [
                                  _cache[77] || (_cache[77] = _createElementVNode("span", { class: "metadata-label" }, "خوانده شده:", -1)),
                                  _createElementVNode("span", _hoisted_143, _toDisplayString(_ctx.selectedLog.isRead ? 'بله' : 'خیر'), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}